import { render, staticRenderFns } from "./ResBanner.vue?vue&type=template&id=472b0797&scoped=true&"
import script from "./ResBanner.vue?vue&type=script&lang=js&"
export * from "./ResBanner.vue?vue&type=script&lang=js&"
import style0 from "./ResBanner.vue?vue&type=style&index=0&id=472b0797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b0797",
  null
  
)

export default component.exports